/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';
import { dataQty } from './shipping-map.data-qty';
import { dataStates } from './shipping-map.data-states';

// @FIXME/vo: Change once global settings have been added for max ship quantity.

// ==============================================================================
// Interfaces
// ==============================================================================
interface IShippingMapListProps {
    statesSettings: { [x: string]: unknown };
}

// ==============================================================================
/**
 * ShippingMapList component
 * @extends {React.PureComponent<IShippingMapListProps>}
 */
// ==============================================================================
class ShippingMapList extends React.PureComponent<IShippingMapListProps> {

    // ------------------------------------------------------
    // ------------------------------------------------------
    public render(): JSX.Element {
        const { statesSettings } = this.props;

        return (
            <ul className='shipping-map-list list-unstyled'>
                {statesSettings && this._renderActiveStatesList(statesSettings)}
            </ul>
        );
    }

    // ------------------------------------------------------
    // ------------------------------------------------------
    private _renderActiveStatesList(states: { [x: string]: unknown }): JSX.Element {
        return (
            <React.Fragment>
                {Object.keys(states).map((state: string, index: number) => states[state] &&
                    <li className='shipping-map-list-item' key={index}>
                        {dataStates && dataStates[state] &&
                            <span className='shipping-map-list-item-state'>
                                {dataStates[state]}
                            </span>
                        }
                        {dataQty && dataQty[state] &&
                            <span className='shipping-map-list-item-qty'>
                                ({dataQty[state]})
                            </span>
                        }
                    </li>
                )}
            </React.Fragment>
        );
    }
}

export default ShippingMapList;